import { useState } from "react";
import Seo from "@/components/Seo";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Fitness Calculator — message from ${form.name || "visitor"}`);
    const body = encodeURIComponent(`${form.message}\n\n— ${form.name}\n${form.email}`);
    window.location.href = `mailto:hello@fitnesscalculator.example?subject=${subject}&body=${body}`;
    toast.success("Opening your email app…");
  };

  return (
    <>
      <Seo title="Contact — Fitness Calculator" description="Have feedback or a calculator idea? Get in touch." path="/contact" />
      <div className="mx-auto max-w-2xl px-4 sm:px-6 py-16">
        <h1 className="text-4xl font-bold tracking-tight">Contact us</h1>
        <p className="mt-3 text-muted-foreground">
          Suggestions, corrections, or a calculator you'd love us to add? We read every message.
        </p>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="contact-form">
          <div className="grid gap-2">
            <Label htmlFor="c-name">Your name</Label>
            <Input id="c-name" data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="c-email">Email</Label>
            <Input id="c-email" data-testid="contact-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="c-msg">Message</Label>
            <Textarea id="c-msg" data-testid="contact-message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
          </div>
          <Button type="submit" data-testid="contact-submit" className="w-full sm:w-auto">Send message</Button>
        </form>
      </div>
    </>
  );
}
